// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"GridSwitcher_wrapperComponent__fNZQ6","gridIcon":"GridSwitcher_gridIcon__RiHze","active":"GridSwitcher_active__6qJRR","name":"GridSwitcher_name__shq7x"};